<template>
    <div>
        <div class="wrapper">
            <canvas
                ref="signature_pad"
                class="signature-pad"
                :width="width"
                :height="height"
            ></canvas>
        </div>
        <div
            v-if="!styleguideIncluded"
            class="signatur-pad-footer"
        >
            <i
                class="icon-trash-o"
                @click="clear()"
            ></i>
        </div>
        <kgr-icon
            v-else
            icon-class="delete"
            class="kgr-icon kgr-icon--small"
            style="margin-top: 5px;"
            @click="clear()"
        />
    </div>
</template>

<script>
import Icon from '../common/icon/Icon.vue'
import SignaturePad from 'signature_pad/dist/signature_pad.js';
import { debounce } from 'lodash';

export default {
    name: 'SignaturePad',

    components: {
        'kgr-icon': Icon,
    },

    props: {
        onFinished: {
            type: Function,
            required: true,
        },
        width: {
            type: Number,
            required: false,
            default: 600,
        },
        height: {
            type: Number,
            required: false,
            default: 200,
        },
        data: {
            type: String,
            required: false,
            default: null,
        },
        styleguideIncluded: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            signaturePad: null,
        }
    },

    mounted() {
        this.signaturePad = new SignaturePad(this.$refs.signature_pad, {
            onEnd: () => {
                this.getSignature()
                    .then((drawing) => {
                        this.onFinished(drawing);
                    });
            }
        });

        this.resizeCanvasDebounce = debounce(() => this.resizeCanvas(), 100);
        window.addEventListener('resize', this.resizeCanvasDebounce);
        this.resizeCanvas();

        if (this.data !== null) {
            this.signaturePad.fromDataURL(this.data, {
                ratio: Math.max(window.devicePixelRatio || 1, 1),
            });
        }
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.resizeCanvasDebounce);
    },

    methods: {
        getSignature() {
            return new Promise((resolve, reject) => {
                const dataURI = this.signaturePad.toDataURL('image/png');

                const image = new Image();
                image.src = dataURI;
                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = this.width;
                    canvas.height = this.height;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(image, 0, 0, this.width, this.height);

                    resolve(canvas.toDataURL('image/jpg'))
                };
                image.onerror = () => reject('failure loading signature')
            })
        },

        resizeCanvas() {
            const dpr = Math.max(window.devicePixelRatio || 1, 1);
            const ratio = this.width / this.height;

            const canvas = this.$refs.signature_pad;
            const wrapper = canvas.parentNode;
            const isEmpty = this.signaturePad.isEmpty();
            const drawing = this.signaturePad.toDataURL()

            if (!canvas) {
                return;
            }
            const ctx = canvas.getContext('2d');

            canvas.width = wrapper.offsetWidth * dpr;
            canvas.height = wrapper.offsetWidth / ratio * dpr;
            ctx.scale(dpr, dpr);

            if (isEmpty) {
                this.signaturePad.clear();
            } else {
                this.signaturePad.fromDataURL(drawing, {
                    ratio: dpr,
                });
            }
        },

        clear() {
            this.signaturePad.clear();
            this.$emit('cleared');
        },
    }
}
</script>

<style
    scoped
    lang="scss"
>
.wrapper {
    position: relative;
    width: 100%;
    max-width: 600px;
    user-select: none;
    z-index: 10;
    overflow:hidden;
}

.signature-pad {
    width: 100%;
    height: auto;
    background-color: white;
    border: 1px solid #a9a9a9;
    border-radius: 10px;
}

.signatur-pad-footer {
    text-align: right;
    padding: 5px 10px 0 0;
    font-size: 17px;
}
</style>
